const USER_ASSIGNMENT_LABEL = {
  TIER_ONE: 'Tier One Curator',
  CURATION: 'Curator',
  QA: 'QA',
  QC: 'QC',
  UNKNOWN_WORDS_CURATION: 'U.W Curator',
  UNKNOWN_WORDS_QA: 'U.W QA',
  SCRAPING_REVIEW: 'Scraping Reviewer',
}

export default USER_ASSIGNMENT_LABEL
